import { DEFAULT_FILL_COLOR, DEFAULT_STROKE_COLOR } from "./constants";

const getCurrentData = (data, storageData) => {
    return storageData
        && storageData.timestamp
        && storageData.timestamp > data.timestamp
        ? storageData
        : data;
}

const migrate = (data, storageData = null) => {
    if (!data) {
        return {};
    }
    let currentData = getCurrentData(data, storageData);
    if (!currentData.version || currentData.version == 0) {
        return migrateToV2(migrateToV1(currentData, data), data);
    } else if (currentData.version == 1) {
        return migrateToV2(currentData, data);
    }
    return currentData;
}

const migrateToV2 = (currentData, data) => {
    let newData = {
        name: currentData.name ? currentData.name : data.name,
        elements: currentData.elements == [] ? data.elements : currentData.elements,
        settings: currentData.settings == {} ? data.settings : currentData.settings,
        view: currentData.view == {} ? data.view : currentData.view,
        species: currentData.species == {} ? data.species : currentData.species,
        image: currentData.image == {} || !currentData.image ? data.image : currentData.image,
        showMigrationMessage: true,
    }
    newData.elements = migrateElementsToV2(newData.elements, newData.species);
    return newData;
};

const migrateElementsToV2 = (elements = [], species = {}) => {
    return elements.map((element) => {
        // Migrate species labels from a simple array of strings to an array of objects
        // e.g. ['Bed 1', 'Carrot'] => [{ type: 'custom', value: 'Bed 1' }, { type: 'species', id: 1, keys: ['name'] }]
        element.data.labels = element.data.labels.filter(l => l).reduce((labels, label) => {
            let [speciesId, key] = element.speciesIds.reduce((acc, speciesId) => {
                return ['name', 'scientific_name', 'parent_name'].reduce((acc2, key) => {
                    return species[speciesId][key] == label
                        ? [speciesId, key]
                        : acc2;
                }, acc);
            }, [null, null]);
            if (speciesId) {
                let speciesLabel = labels.find(l => l.type == 'species' && l.id == speciesId);
                if (speciesLabel) {
                    speciesLabel.keys.push(key);
                } else {
                    labels.push({ type: 'species', id: speciesId, keys: [key] });
                }
            } else {
                labels.push({ type: 'custom', value: label, visible: true });
            }
            return labels;
        }, []);
        element.speciesIds.map((speciesId) => {
            let speciesLabel = element.data.labels.find(l => l.type == 'species' && l.id == speciesId);
            if (!speciesLabel) {
                element.data.labels.push({ type: 'species', id: speciesId, keys: [] });
            }
        });
        if (element.data.name) {
            element.data.labels.unshift({ type: 'custom', value: element.data.name, visible: false });
        }
        delete element.data.name;
        return element;
    });

}

const migrateToV1 = (currentData, data) => {
    let newData = {
        name: currentData.name ? currentData.name : data.name,
        elements: migratePlantsToV1(currentData.plants == [] ? data.plants : currentData.plants).concat(migrateShapesToV1(currentData.shapes == [] ? data.shapes : currentData.shapes)),
        settings: currentData.settings == {} ? data.settings : currentData.settings,
        view: migrateViewToV1(currentData.view == {} ? data.view : currentData.view),
        species: currentData.species == {} ? data.species : currentData.species,
        showMigrationMessage: true,
    }
    if (!newData.settings.name) {
        newData.settings.name = newData.name;
    }
    return newData;
}

const migratePlantsToV1 = (plants = []) => {
    return plants.map((plant) => {
        let label = plant.label;
        return {
            type: 'ellipse',
            data: {
                x: plant.x,
                y: plant.y,
                width: plant.size * 100,
                height: plant.size * 100,
                labels: label && label != '' ? [label] : [],
                labelX: 0,
                labelY: 0,
                fillColor: DEFAULT_FILL_COLOR,
                strokeColor: null,
                strokeWidth: null,
            },
            speciesIds: [plant.plant_id],
        };
    });
}

const migrateShapesToV1 = (shapes = []) => {
    return shapes.map((shape) => {
        let label = shape.data.label;
        return {
            type: shape.type,
            data: Object.assign(
                shape.data,
                {
                    fillColor: null,
                    strokeColor: DEFAULT_STROKE_COLOR,
                    strokeWidth: null,
                },
                {
                    labels: label && label != '' ? [label] : [],
                    labelX: 0,
                    labelY: 0,
                }
            ),
            speciesIds: [],
        };
    });
}

const migrateViewToV1 = (view = {}) => {
    return view.zoomLevel == undefined
        ? {}
        : {
            scale: 1.2 ** view.zoomLevel,
            posX: view.posX,
            posY: view.posY,
        }
}

export { migrate };
